import { useEffect } from "react";
import { type PageName, tracking } from "./tracking";

export function useTrackPageView(pageName: PageName) {
	useEffect(() => {
		tracking.trackPageView(pageName);
	}, [pageName]);
}
